import React from "react";
import { useLocation } from "react-router-dom";

const Details = () => {
  const location = useLocation();
  const {
    title,
    liveSite,
    clientRepo,
    serverRepo,
    image,
    details,
    technologies,
    points,
    screenShots,
  } = location.state;
  return (
    <div className="p-10">
      <div className="card shadow-slate-500 shadow-md p-2">
        <figure>
          <img
            className="h-64 w-full md:w-2/3 lg:w-1/4"
            src={image}
            alt="react project"
          />
        </figure>
        <div className="card-body">
          <h2 className="card-title">{title}</h2>
          <p className="text-left">{details}</p>
          <p className="text-left">Technologies: {technologies}</p>
          <div>
            <p className="text-left">Key Points:</p>
            {points.map((point) => (
              <li className="text-left capitalize">{point}</li>
            ))}
          </div>
          <div className="card-actions justify-center mt-5 flex">
            <div className="badge badge-secondary">
              <a href={liveSite} target="_blank">
                Live
              </a>
            </div>
            <div className="badge badge-secondary">
              <a target="_blank" href={clientRepo}>
                Client Repo
              </a>
            </div>
            <div className="badge badge-secondary">
              <a target="_blank" href={serverRepo}>
                Server Repo
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-12">
        <h2 className="text-xl font-bold text-center mb-6">Screen Shots</h2>
        {screenShots.map((screenShot) => (
          <div className="my-10">
            <img src={screenShot} alt={title}></img>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Details;
